"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImgSrcFromDom = void 0;
/**
 * 获取图片 src
 */
var getImgSrcFromBgImg = function getImgSrcFromBgImg() {
  var bgImg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var imgSrc = '';
  var matches = bgImg.match(/url\(.*?\)/g);
  if (matches && matches.length) {
    var urlStr = matches[matches.length - 1]; // use the last one
    var innerUrl = urlStr.replace(/^url\(['"]?/, '').replace(/['"]?\)$/, '');
    if (/^http/.test(innerUrl) || /^\/\//.test(innerUrl)) {
      imgSrc = innerUrl;
    }
  }
  return imgSrc;
};
//
var isImg = function isImg(src, imgFilter) {
  for (var i = 0, len = imgFilter.length; i < len; i++) {
    if (imgFilter[i].test(src)) {
      return true;
    }
  }
  return false;
};
//
var getImgSrcFromDom = exports.getImgSrcFromDom = function getImgSrcFromDom(dom, imgFilter) {
  if (!(dom.getBoundingClientRect && dom.getBoundingClientRect().top < window.innerHeight)) return '';
  imgFilter = [/(\.)(png|jpg|jpeg|gif|webp|ico|bmp|tiff|svg)/i];
  var src = '';
  if (dom.nodeName.toUpperCase() == 'IMG') {
    src = dom.getAttribute('src');
  } else {
    var computedStyle = window.getComputedStyle(dom);
    var bgImg = computedStyle.getPropertyValue('background-image') || computedStyle.getPropertyValue('background');
    var tempSrc = getImgSrcFromBgImg(bgImg);
    if (tempSrc && isImg(tempSrc, imgFilter)) {
      src = tempSrc;
    }
  }
  return src;
};